import Login from './Login/Login';
import Home from './Home/Home';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import './App.css';
import {AuthProvider} from "./context/AuthContext";
import VoterRegistration from "./RegistrarVotante/RegistrarVotante";
import AddCampaign from "./Campaigns/AddCampaign";
import EditCampaign from "./Campaigns/EditCampaign";
import CampaignDetails from "./Campaigns/CampaignDetails";
import AddCandidate from "./Candidate/AddCandidate";

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Navigate to="/home" />} />

                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<VoterRegistration />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/add-campaign" element={<AddCampaign />} />
                    <Route path="/edit-campaign/:id" element={<EditCampaign />} />
                    <Route path="/campaign/:id" element={<CampaignDetails />} />
                    <Route path="/add-candidate/:id" element={<AddCandidate />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;